export enum FeedbackMessageTypesEnum {
  ERROR,
  INFORMATIVE,
}
